var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "#DB0011",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.85 15.044v.012l1.05 12.918a2.37 2.37 0 0 0 2.357 2.35h8.458a2.35 2.35 0 0 0 2.356-2.35l1.05-12.918h.001v-.012c0-.134-.024-.315-.163-.439a.45.45 0 0 0-.405-.21H12.473a.57.57 0 0 0-.462.218l.12.09-.12-.09a.76.76 0 0 0-.161.431Zm13.03 12.86v.038c0 .627-.51 1.137-1.137 1.137h-8.46c-.625 0-1.136-.51-1.136-1.137v-.038L13.16 15.64h12.73zm1.647-16.19h-3.396v-.928a1.94 1.94 0 0 0-1.937-1.936l-3.361.001a1.94 1.94 0 0 0-1.937 1.936v.928l-3.423-.001a.62.62 0 0 0-.623.623c0 .35.31.623.623.623h14.054a.62.62 0 0 0 .623-.623.62.62 0 0 0-.623-.623Zm-9.411-.928c0-.39.327-.717.717-.717h3.362c.39 0 .718.327.718.717v.928h-4.797z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.143 26.34-.001-7.96a.62.62 0 0 0-.623-.623.62.62 0 0 0-.623.623v7.96a.623.623 0 1 0 1.247 0Zm2.37.623a.62.62 0 0 0 .623-.623v-7.96a.62.62 0 0 0-.623-.623.62.62 0 0 0-.623.623v7.96c0 .346.278.623.623.623Zm2.372-.623v.015c.034.325.296.608.623.608a.62.62 0 0 0 .623-.623v-7.96a.62.62 0 0 0-.623-.623.62.62 0 0 0-.623.623z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.dd63668e65d0d28a04d03b6a320fd649.svg";
export { ForwardRef as ReactComponent };